import { $authHost } from "../index"

export const getWorkLinePlaceGroupAPI = async ({ workLinePlaceId }) => {
    const {data} = await $authHost.post('api/work_line_place_group/get_by_work_line_place', {workLinePlaceId})
    return data
}

export const addWorkLinePlaceGroupAPI = async ({ usersWork, workLinePlaceId }) => {
    const {data} = await $authHost.post(`api/work_line_place_group/${workLinePlaceId}`, { usersWork })
    return data
}